import { collection, doc, getDocs, getCountFromServer, limit, onSnapshot, orderBy, query, setDoc, startAfter, Timestamp, updateDoc, where } from "firebase/firestore";
import { db } from '@/firebase/firebaseInit';

var listenFD;
var listenNextFD;

export default {

    async createFD(context, payload) {

        await setDoc(doc(db, "fds/" + payload.fdID), {
            id: parseInt(payload.fdID),
            date: Timestamp.fromDate(payload.fdDate),
            time: payload.time,
            status: 'DRAFT',
            sponsor: payload.sponsor,
            volunteers_drivers_remaining: payload.drivingVolunteers,
            volunteers_drivers_required: payload.drivingVolunteers,
            volunteers_others_remaining: payload.otherVolunteers,
            volunteers_others_required: payload.otherVolunteers,
            sponsor_volunteers_drivers_remaining: payload.sponsorDrivingVolunteers,
            sponsor_volunteers_drivers_required: payload.sponsorDrivingVolunteers,
            sponsor_volunteers_others_remaining: payload.sponsorOtherVolunteers,
            sponsor_volunteers_others_required: payload.sponsorOtherVolunteers,
            tbr_volunteers_required: payload.tbrVolunteers,
            tbr_volunteers_remaining: payload.tbrVolunteers,
            sponsor_tbr_volunteers_required: payload.sponsorTbrVolunteers,
            sponsor_tbr_volunteers_remaining: payload.sponsorTbrVolunteers,
            statsVersion: 3
        });
    },

    async changeFDStatus(context, payload) {
        console.log("Changing FD: " + payload.fdID + " status to: " + payload.status);
        const fdRef = doc(db, "fds/" + String(payload.fdID));

        if (payload.status === 'CLOSED' && context.getters['getCurrentFD'].statsVersion === 3) {
            const ref = collection(db, 'fds', String(payload.fdID), 'deliveries');
            const countQ = (filters) => getCountFromServer(query(ref, ...filters));
            const lRH = [where('location', '==', 'REDHILL')];
            const lTBR = [where('location', '==', 'TBR')];

            const [
                rhTotal, rhSelfTotal, rhSelfDone,
                rhDrivingTotal, rhDrivingDelivered, rhDrivingNotDelivered,
                rhTotalDelivered, rhTotalNotDelivered, rhTotalPending,
                tbrTotal, tbrDone,
            ] = await Promise.all([
                countQ([...lRH]),
                countQ([...lRH, where('self_collection', '==', true)]),
                countQ([...lRH, where('self_collection', '==', true), where('completed', '==', true)]),
                countQ([...lRH, where('driving_delivery', '==', true)]),
                countQ([...lRH, where('driving_delivery', '==', true), where('status', '==', 'DELIVERED')]),
                countQ([...lRH, where('driving_delivery', '==', true), where('status', '==', 'NOT_DELIVERED')]),
                countQ([...lRH, where('status', '==', 'DELIVERED')]),
                countQ([...lRH, where('status', '==', 'NOT_DELIVERED')]),
                countQ([...lRH, where('completed', '==', false)]),
                countQ([...lTBR]),
                countQ([...lTBR, where('completed', '==', true)]),
            ].map(p => p.then(s => s.data().count)));

            const rhSelfPending = rhSelfTotal - rhSelfDone;
            const rhDrivingPending = rhDrivingTotal - rhDrivingDelivered - rhDrivingNotDelivered;
            const rhWalkingTotal = rhTotal - rhSelfTotal - rhDrivingTotal;
            const rhWalkingDelivered = rhTotalDelivered - rhDrivingDelivered;
            const rhWalkingNotDelivered = rhTotalNotDelivered - rhDrivingNotDelivered;
            const rhWalkingPending = rhTotalPending - rhSelfPending - rhDrivingPending;

            const final_stats = {
                selfRedhill: { total: rhSelfTotal,    done: rhSelfDone,              pending: rhSelfPending },
                selfTbr:     { total: tbrTotal,        done: tbrDone,                 pending: tbrTotal - tbrDone },
                walking:     { total: rhWalkingTotal,  delivered: rhWalkingDelivered, notDelivered: rhWalkingNotDelivered, pending: rhWalkingPending },
                driving:     { total: rhDrivingTotal,  delivered: rhDrivingDelivered, notDelivered: rhDrivingNotDelivered, pending: rhDrivingPending },
                grandTotal:  { total: rhTotal + tbrTotal, delivered: rhTotalDelivered, notDelivered: rhTotalNotDelivered, pending: rhTotalPending + (tbrTotal - tbrDone) },
            };

            await updateDoc(fdRef, { status: payload.status, final_stats });
        } else {
            await updateDoc(fdRef, { status: payload.status });
        }
    },

    async updateTeams(context, payload) {
        console.log("Updating team for FD");
        const fdRef = doc(db, "fds/" + String(payload.fdID));
        await updateDoc(fdRef, {
            teams_driving: payload.drivingTeams,
            teams_walking: payload.walkingTeams,
            deliveries_assigned_to_teams: false
        });
    },

    async updateFDDetails(context, payload) {
        const fdRef = doc(db, "fds/" + String(payload.fdID));
        await updateDoc(fdRef, {
            volunteers_drivers_required: payload.requiredDriving,
            volunteers_drivers_remaining: payload.remainingDriving,
            volunteers_others_required: payload.requiredOthers,
            volunteers_others_remaining: payload.remainingOthers,
            tbr_volunteers_required: payload.tbrRequired,
            tbr_volunteers_remaining: payload.tbrRemaining,
            sponsor_volunteers_drivers_required: payload.sponsorRequiredDriving,
            sponsor_volunteers_drivers_remaining: payload.sponsorRemainingDriving,
            sponsor_volunteers_others_required: payload.sponsorRequiredOthers,
            sponsor_volunteers_others_remaining: payload.sponsorRemainingOthers,
            sponsor_tbr_volunteers_required: payload.sponsorTbrRequired,
            sponsor_tbr_volunteers_remaining: payload.sponsorTbrRemaining,
            sponsor: payload.sponsor,
            time: payload.time
        });
    },

    async fetchOpenFDs(context) {
        const q = query(
            collection(db, "fds"),
            where("date", ">=", Timestamp.fromDate(new Date())),
            orderBy("date")
        );
        const snap = await getDocs(q);
        const fds = [];
        snap.forEach(d => {
            const fd = d.data();
            if (fd.status === 'DRAFT') fds.push(fd);
        });
        context.commit('setFDs', fds);
    },

    async fetchFDs(context) {
        const q = query(collection(db, "fds"), where("date", ">=", new Date()))
        const querySnapshot = await getDocs(q);

        if (querySnapshot.size == 0) {
            throw new Error("No future FDs found!");
        }

        const fds = [];

        querySnapshot.forEach((doc) => {
            const fd = doc.data();
            fds.push(fd);
        });
        console.log("FDs received: ", fds)
        context.commit('setFDs', fds);
    },

    async fetchPastFDs(context) {
        const PAGE_SIZE = 12;
        const lastDoc = context.state.lastPastFDDoc;

        const constraints = [
            where("date", "<", Timestamp.fromDate(new Date())),
            orderBy("date", "desc"),
            limit(PAGE_SIZE + 1),
        ];
        if (lastDoc) constraints.push(startAfter(lastDoc));

        const querySnapshot = await getDocs(query(collection(db, "fds"), ...constraints));

        if (querySnapshot.size === 0 && !lastDoc) {
            throw new Error("No past FDs found!");
        }

        const docs = querySnapshot.docs;
        const hasMore = docs.length > PAGE_SIZE;
        const pageDocs = hasMore ? docs.slice(0, PAGE_SIZE) : docs;

        context.commit('appendPastFDs', pageDocs.map(d => d.data()));
        context.commit('setPastFDCursor', hasMore ? pageDocs[pageDocs.length - 1] : null);
        context.commit('setHasMorePastFDs', hasMore);
    },

    findNextFD(context) {
        const q = query(collection(db, "fds"), where("date", ">=", new Date()), orderBy("date"), limit(1));
        listenNextFD = onSnapshot(q, (querySnapshot) => {
            querySnapshot.forEach((doc) => {
                context.commit("setCurrentFD", doc.data());
            });
        });
    },

    unsubscribeNextFD() {
        if (listenNextFD) {
            listenNextFD();
        }
    },

    listenFDbyID(context, payload) {
        if (listenFD) listenFD();
        const docRef = doc(db, "fds", payload);
        listenFD = onSnapshot(docRef,
            (snap) => {
                context.commit("setCurrentFD", snap.data() ?? null);
                context.commit("setFDError", null);
            },
            (error) => {
                console.error('[fd] listenFDbyID error:', error);
                context.commit("setFDError", error.message);
            }
        );
    },

    unsubscribeFD() {
        if (listenFD) {
            listenFD();
        }
    },

    async fetchLiveFD(context) {
        const q = query(
            collection(db, "fds"),
            where("date", ">=", Timestamp.fromDate(new Date())),
            where("status", "==", "LIVE"),
            orderBy("date"),
            limit(1)
        );
        const snap = await getDocs(q);
        let liveFD = null;
        snap.forEach(d => { liveFD = d.data(); });
        context.commit('setLiveFD', liveFD);
    },
}

